import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  transactions : [],
  error : null
};


export const TRANSACTION_URL = "admin/transaction";

export const getTransactions = createAsyncThunk(
    TRANSACTION_URL + "/get-transaction",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(TRANSACTION_URL);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

const settingSlice = createSlice({
    name : "transaction",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(getTransactions.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getTransactions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.transactions = action.payload;
            })
            .addCase(getTransactions.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default settingSlice.reducer